<template>
<div>
  <div>
    <div class="h-panel">
      <b-button
        v-if="mayManage"
        :to="{name: 'derby_template_add'}"
        variant="primary">
        Add a template
      </b-button>
    </div>

    <h2>Derbies templates</h2>

    <p v-show="templates.length == 0">
      Derby list is empty!
    </p>

    <table v-show="templates.length > 0" class="table table-bordered table-hover text-nowrap">
      <thead class="thead-dark">
        <tr>
          <th>№</th>
          <th>Name</th>
          <th>Min<br>player<br>level</th>
          <th>Max<br>player<br>level</th>
          <th>Max<br>participants</th>
          <th>Target<br>score</th>
          <th>Score<br>threshold</th>
          <th>Score<br>emul<br>time<br>step</th>
          <th>Score<br>emul<br>time<br>total</th>
          <th>Rewards</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="template in templates" :key="template.id">
          <td>{{ template.id }}</td>
          <td>{{ template.name }}</td>
          <td>{{ template.min_player_level }}</td>
          <td>{{ template.max_player_level }}</td>
          <td>{{ template.max_participants }}</td>
          <td>{{ template.target_score }}</td>
          <td>{{ template.score_threshold }}</td>
          <td>{{ template.score_emul_time_step | getDurationStr }}</td>
          <td>{{ template.score_emul_time_total | getDurationStr }}</td>
          <td>
            <b-button size="sm" 
              v-b-modal.rewards-modal 
              @click="setRewards(template.rewards)">
              Show
            </b-button>
          </td>
          <td>
            <b-button size="sm" class="ml-2" variant="success"
              v-if="mayManage"
              :to="{name: 'derby_template_edit', params: {templateId: template.id}}">
              Edit
            </b-button>
            <b-button size="sm" class="ml-2" variant="danger"
              v-if="mayManage"
              @click="deleteTemplateWithConfirmation(template)">
              Delete
            </b-button>
          </td>
        </tr>
      </tbody>
    </table>

    <loading-indicator v-if="isLoading"></loading-indicator>

    <b-modal id="rewards-modal" title="Rewards" ok-only ok-title="Close" size="xl">
      <table class="table">
        <thead class="thead-dark">
          <tr>
            <th>Place</th>
            <th>Item</th>
            <th>Amount</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(reward, index) in rewards" :key="index">
            <td>{{ reward.place }}</td>
            <td>{{ reward.proto_id | getProtoAlias }}</td>
            <td>{{ reward.amount }}</td>
          </tr>          
        </tbody>
      </table>
    </b-modal>
  </div>
</div>
</template>

<script>
import LoadingIndicator from '../LoadingIndicator.vue';

import auth from '../../auth.js';
import { HTTP } from '../../http-common.js';
import { confirmAction } from '../../service/confirm.js';
import notifier from '../../notifier.js';
import { arrayDeleteFirstItemByValue } from '../../util.js';
import { isRoleAdmin } from '../../util.js';

export default {
  name: 'DerbyTemplateList',
  components: {
    LoadingIndicator,
  },

  created() {
    this.loadTemplates();
  },

  data() {
    return {
      actor: auth.getViewer(),
      isLoading: false,
      templates: [],
      rewards: [],
    };
  },
  
  computed: {
    mayManage() {
      return isRoleAdmin(this.actor.role);
    },
  },
  
  methods: {
    loadTemplates() {
      notifier.deleteSenderNotifications(this);

      this.isLoading = true;

      HTTP.get('/derbies/templates')
      .then(response => {
        const data = response.data.data;
        if(data === null) {
          notifier.showError('Invalid server response. data === null.', {sender: this});
          return;
        }

        this.templates = data.templates || [];
      })
      .catch(e => {
        notifier.showError(e, {sender: this});
      })
      .finally(() => {
        this.isLoading = false;
      });
    },

    setRewards(rewards) {
      this.rewards = rewards;
    },

    deleteTemplateWithConfirmation(template) {
      notifier.deleteSenderNotifications(this);

      confirmAction(
        this,
        'Are you sure you want to delete this template {env}?',
        'Delete',
        () => {
          this.deleteTemplate(template);
        },
      );
    },

    deleteTemplate(template) {
      notifier.deleteSenderNotifications(this);
      
      const url = `/derbies/templates/${template.id}/delete`;
      HTTP.post(url)
      .then(response => {
        const result = response.data.result;
        if (result.code) {
          notifier.showError(result.message, {sender: this});
          return;
        }

        arrayDeleteFirstItemByValue(this.templates, template);
        notifier.showSuccess('Derby template deleted.');
      })
      .catch(e => {
        notifier.showError(e, {sender: this});
      });
    },
  },
}
</script>

<style scoped>
</style>